import { View } from 'components/View'
import React from 'react'

function Flex (props) {
  return (
    <View
      f
      {...props}
    />
  )
}

export default Flex
